/**
 * 所有已知路由的 path pattern，用于 404 短路判断。
 * 独立模块，不引入任何页面组件，保证 404 页面零冗余加载。
 *
 * ⚠️ 新增路由时请同步更新此列表。
 */
export const knownRoutePatterns = [
	{ path: "/login" },
	{ path: "/legal/user-agreement" },
	{ path: "/legal/privacy-policy" },
	{ path: "/" },
	// Admin
	{ path: "/admin" },
	{ path: "/admin/organizations" },
	{ path: "/admin/users" },
	{ path: "/admin/roles" },
	{ path: "/admin/api-keys" },
	{ path: "/admin/nemo-agent-keys" },
	{ path: "/admin/usage" },
	{ path: "/admin/usage/records" },
	{ path: "/admin/finance" },
	{ path: "/admin/rebates" },
	{ path: "/admin/pricing" },
	{ path: "/admin/models" },
	{ path: "/admin/notifications" },
	// Director
	{ path: "/styles" },
	{ path: "/assets" },
	{ path: "/nemo-agent" },
	{ path: "/finance" },
	{ path: "/scripts" },
	{ path: "/scripts/:id" },
	{ path: "/scripts/:id/workbench" },
	{ path: "/scripts/:id/canvas" },
	{ path: "/scripts/:id/episodes/:episodeId/canvas" },
	{ path: "/scripts/:scriptId/characters/:characterId" },
	{ path: "/scripts/:scriptId/scenes/:sceneId" },
	{ path: "/scripts/new" },
	{ path: "/scripts/new/from-script" },
	{ path: "/scripts/new/quick-generate" },
	{ path: "/planning" },
	{ path: "/planning/new" },
	{ path: "/planning/:planId" },
	{ path: "/assignments" },
	{ path: "/notifications" },
	{ path: "/director/scripts/:id/review" },
	{ path: "/director/characters" },
	{ path: "/director/characters/:id" },
	{ path: "/director/scenes" },
	{ path: "/director/scenes/:id" },
];
